export enum EMissionDetailSegment {
  MISSION = 'view',
  CHAT = 'chat',
  SOLUTION = 'solution',
  REPORT = 'report'
}
